/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EDFOAContractActionStatus } from '../models/EDFOAContractActionStatus';
import type { PaginatedEDFOAContractActionStatusList } from '../models/PaginatedEDFOAContractActionStatusList';
import type { PatchedEDFOAContractActionStatus } from '../models/PatchedEDFOAContractActionStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsEdfOaContractActionStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEDFOAContractActionStatusList
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEDFOAContractActionStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-edf-oa-contract-action-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EDFOAContractActionStatus
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusCreate({
        requestBody,
    }: {
        requestBody: EDFOAContractActionStatus,
    }): CancelablePromise<EDFOAContractActionStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-edf-oa-contract-action-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EDFOAContractActionStatus
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this edfoa contract action status.
         */
        id: number,
    }): CancelablePromise<EDFOAContractActionStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-edf-oa-contract-action-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EDFOAContractActionStatus
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this edfoa contract action status.
         */
        id: number,
        requestBody: EDFOAContractActionStatus,
    }): CancelablePromise<EDFOAContractActionStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-edf-oa-contract-action-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EDFOAContractActionStatus
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this edfoa contract action status.
         */
        id: number,
        requestBody?: PatchedEDFOAContractActionStatus,
    }): CancelablePromise<EDFOAContractActionStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-edf-oa-contract-action-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsEdfOaContractActionStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this edfoa contract action status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-edf-oa-contract-action-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
